import { defaultProfilePicFileName, getProfilePicPath } from "../../constants/instructorConstants";
import { getApiUrl } from "../../constants/pathConstants"
import { communityStateData } from "../../data/communityStateData"
import { UserPostComment } from '../../types/posts';
import { API_END_POINT_CREATE_NEW_COMMENT, API_END_POINT_GET_COMMENTS_FOR_POST } from "../endPoints";

type ServerCommentData = {
	id: string
	user_id: string
	post_id: string
	comment_str: string
	create_date: string
	profile_pics: string
	name: string
}

function NewCommentFactory(comment: ServerCommentData): UserPostComment {
	return {
		commentId: comment.id,
		sourceUserId: comment.user_id,
		sourceName: comment.name,
		sourceImgSrc: comment.profile_pics ? getProfilePicPath(comment.profile_pics, 0) : getProfilePicPath(defaultProfilePicFileName, 0),
		commentDate: new Date(comment.create_date).getTime(),
		commentMsg: comment.comment_str
	}
}

class CommentConnector {
	requestInProgress: boolean = false

	public async getCommentsForPostRequest(postId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [CommentConnector] getCommentsForPostRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", postId)
				urlParams.append("cache", `${Math.floor(Math.random() * 10000)}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_COMMENTS_FOR_POST}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						// console.log(data)
						if (data.comments) {
							// communityStateData.userPosts = data.posts
							let newComments: UserPostComment[] = []
							data.comments.forEach((comment: ServerCommentData) => {
								newComments.push(NewCommentFactory(comment))
							});
							// load any user details for ids which are included in posts
							communityStateData.loadedComments = newComments

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[CommentConnector] - getCommentsForPostRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performCreateCommentRequest(
		user_id: string,
		post_id: string,
		comment_str: string
	):  Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] performCreateCommentRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_CREATE_NEW_COMMENT}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"user_id": user_id,
						"post_id": post_id,
						"comment_str": comment_str
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - performCreateCommentRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const commentConnector: CommentConnector = new CommentConnector()